
import { defineComponent, onMounted } from 'vue'
import PaymentAdminApi from '@/core/services/payment/PaymentAdminApi'
import { usePaginatedList } from '@/core/composables/usePaginatedList'
import { formatDateTime, formatMoney } from '@/core/helpers/paymentFormat'
import { paymentStatusLabels, toOptions } from '@/core/services/payment/labels'
import { PaymentRow } from '@/core/services/payment/types'
import PaymentListLayout from '@/core/components/payment/PaymentListLayout.vue'
import NewTabLink from '@/core/components/payment/NewTabLink.vue'
import PaymentStatusTag from '@/core/components/payment/PaymentStatusTag.vue'

export default defineComponent({
  name: 'PaymentsList',
  components: { PaymentListLayout, PaymentStatusTag, NewTabLink },
  setup() {
    const list = usePaginatedList<PaymentRow>(PaymentAdminApi.payments.list, {
      defaults: {
        status: [],
        order_id: '',
        gateway_transaction_id: '',
        gateway_type: '',
        amount_from: '',
        amount_to: '',
        created_from: '',
        created_to: '',
      },
    })
    onMounted(list.init)

    return {
      ...list,
      statusOptions: toOptions(paymentStatusLabels),
      money: formatMoney,
      dateTime: formatDateTime,
    }
  },
})
